import React from "react";
import "./css/procedimientos.css"; // Optional, for styling

function Procedimientos() {
  return (
    <div>
      <h2>Procedimientos Module</h2>
      <p>This is the Procedimientos view.</p>
    </div>
  );
}

export default Procedimientos;
